module.exports = __webpack_public_path__ + "img/EY__bg_lg.dc6e5502.png";